const DEFAULT_API_BASE_URL = "/";

// -------------------------------------------------------------------------------------------------------
// 1. API URL BUILDER

export const getApiBaseUrl = () => {
  const configuredBaseUrl = process.env.REACT_APP_BASE_API || DEFAULT_API_BASE_URL;

  if (
    process.env.NODE_ENV === "development"
    && typeof window !== "undefined"
    && configuredBaseUrl !== DEFAULT_API_BASE_URL
  ) {
    const apiUrl = new URL(configuredBaseUrl, window.location.origin);
    const localHosts = new Set(["localhost", "127.0.0.1"]);

    if (
      localHosts.has(apiUrl.hostname)
      && localHosts.has(window.location.hostname)
    ) {
      apiUrl.hostname = window.location.hostname;
      return apiUrl.toString();
    }
  }

  return configuredBaseUrl;
};

export const getApiUrl = (path) => {
  const baseUrl = getApiBaseUrl();
  const cleanBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;

  return `${cleanBaseUrl}${cleanPath}`;
};
